import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  useDisclosure,
  Box,
  Text,
} from "@chakra-ui/react";

import { Body } from "./Body";
import { ButtonCard } from "../Card/ButtonCard";
import { FC, memo, useContext, useEffect, useState } from "react";
import { TypeSelectedData } from "../../types/TypeSelectedData";
import {
  ImagePageContextProvider,
  LikeButtonFlagContextProvider,
  ModalContext,
  RenderContext,
} from "../../CreateContext";
import "../../../css/MobileDetailDialog.scss";
import {
  AiFillCloseCircle,
  AiFillInstagram,
  AiFillTwitterCircle,
  AiOutlineYoutube,
} from "react-icons/ai";
import { BsBellFill, BsFacebook, BsNewspaper } from "react-icons/bs";
import { RiTwitterXFill } from "react-icons/ri";
import { MyModalHeader } from "./ModalHeader";
import { ModalView } from "./ModalView";
import { HeightCalculation, WidthCalculation } from "../../SizeCaluculation";

type Props = TypeSelectedData & {
  length?: number;
};

export const Model: FC<Props> = memo((props) => {
  //  Props from DataCard
  const {
    Title,
    Medias,
    WallLikes,
    TopicAuthorName,
    TopicBody,
    CategoryID,
    TopicID,
    length,
  } = props;
  const { settings } = useContext(RenderContext);

  const modalIsGallery = settings.find(
    (setting) => setting.KEY_NAME === "modal_is_gallery"
  );
  const modalLayout =
    typeof modalIsGallery?.VALUE === "boolean" ? modalIsGallery.VALUE : true;

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [LikeCount, setLikeCount] = useState(WallLikes);
  const { setModalOpen } = useContext(ModalContext);

  useEffect(() => {
    setLikeCount(WallLikes);
  }, [WallLikes]);

  // cursorがtrueかどうか調べる
  const searchParams = new URLSearchParams(window.location.search);
  const cursor = searchParams.get("cursor");

  useEffect(() => {
    setModalOpen(isOpen);
  }, [isOpen]);

  let ModalIcon = BsFacebook;
  let TypeMenu: string = "";

  if (CategoryID == 2) {
    TypeMenu = "twitter";
    ModalIcon = RiTwitterXFill;
  } else if (CategoryID == 1) {
    TypeMenu = "user_news";
    ModalIcon = BsBellFill;
  } else if (CategoryID == 4) {
    TypeMenu = "youtube";
    ModalIcon = AiOutlineYoutube;
  } else if (CategoryID == 3) {
    TypeMenu = "instagram";
    ModalIcon = AiFillInstagram;
  } else {
    TypeMenu = "university_news";
    ModalIcon = BsNewspaper;
  }

  return (
    <ImagePageContextProvider>
      <Box
        onClick={onOpen}
        display="inline-flex"
        alignItems="center"
        py={`${HeightCalculation(15, 15)}px`}
        w="auto"
      >
        <ButtonCard
          Title={Title}
          Medias={Medias}
          WallLikes={WallLikes}
          TopicAuthorName={TopicAuthorName}
          TopicBody={TopicBody}
          CategoryID={CategoryID}
          TypeMenu={TypeMenu}
          TopicID={TopicID}
          length={length}
          LikeCount={LikeCount}
          setLikeCount={setLikeCount}
          ModalLayout={modalLayout ? 1 : 0}
        />
      </Box>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="full"
        motionPreset="scale"
        scrollBehavior="inside"
      >
        <ModalOverlay />
        {!modalLayout && (
          <ModalContent bg="transparent" backdropFilter="blur(10px)">
            <Box
              marginTop={`${HeightCalculation(80, 540)}px`}
              marginLeft={`${WidthCalculation(48, 20)}px`}
              minHeight={`${HeightCalculation(1015, 1050)}px`}
              width={`${window.innerWidth * 0.96}px`}
              borderRadius="16px"
            >
              <MyModalHeader
                TopicAuthorName={TopicAuthorName}
                TypeMenu={TypeMenu}
                ModalIcon={ModalIcon}
                onClose={onClose}
              />
              <ModalBody p="0px">
                <Body
                  ModalLayout={0}
                  Title={Title}
                  Medias={Medias}
                  WallLikes={WallLikes}
                  TopicAuthorName={TopicAuthorName}
                  TopicBody={TopicBody}
                  TopicID={TopicID}
                  TypeMenu={TypeMenu}
                  isOpen={isOpen}
                  onClose={onClose}
                  LikeCount={LikeCount}
                  setLikeCount={setLikeCount}
                />
              </ModalBody>
            </Box>
          </ModalContent>
        )}
        {modalLayout && (
          <ModalView
            id={TopicID}
            onClose={onClose}
            isOpen={isOpen}
            cursor={cursor}
            LikeCount={LikeCount}
            setLikeCount={setLikeCount}
          />
        )}
      </Modal>
    </ImagePageContextProvider>
  );
});
